import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { TOLL_PATH, NEW_TOLL_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { TOLL_COLUMNS } from '../../../../config/columns';
import { clearTolls, getTolls } from '../../../../actions';

export const Tolls = ({
  breadcrumbs,
  tolls,
  loading,
  dispatchGetTolls,
  dispatchClearTolls,
}) => {
  useLayoutEffect(() => () => dispatchClearTolls(), []);

  const data = tolls.get('content') || [];
  const pages = tolls.get('totalPages') || null;
  const defaultPageSize = tolls.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Peajes"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_TOLL_PATH}
      tableStructure={{
        columns: TOLL_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetTolls,
        modelPath: TOLL_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetTolls: getTolls,
  dispatchClearTolls: clearTolls,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Peajes',
      href: TOLL_PATH,
    },
  ],
  tolls: RouteUnit.Toll.getIn(['all', 'content']),
  loading: RouteUnit.Toll.getIn(['all', 'loading']),
});

Tolls.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  tolls: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetTolls: PropTypes.func.isRequired,
  dispatchClearTolls: PropTypes.func.isRequired,
};

Tolls.defaultProps = {
  tolls: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tolls);
